import { CloseButton, Flex, Label, Spacer, Text } from '@zillow/constellation';
import { Col } from '@zg-rentals/zrs-comet';
import { Datepicker } from '@zillow/zrs-rentals';
import { StyledPill } from './StyledComponents';
import type { AdvancedTableFilterConfig } from '../AdvancedTable';

type DateFilterPillProps = {
  filters: AdvancedTableFilterConfig;
  handleChange: (value: string | number | Date) => void;
  handleClearFilter: (value: string | number | Date | undefined) => void;
  isDateEnabled?: (date: string | number | Date, filters: AdvancedTableFilterConfig) => boolean;
  isFilterOpen?: boolean;
  keyName: string;
  title?: string;
  value: string | number | Date | undefined;
};

function isDateInFuture(date: Date) {
  const now = new Date();
  now.setHours(23, 59, 59, 998);
  return date > now;
}

export const DateFilterPill = ({
  filters,
  handleChange,
  handleClearFilter,
  isDateEnabled,
  isFilterOpen = false,
  keyName,
  title = '',
  value,
}: DateFilterPillProps) => {
  if (!isFilterOpen && !value) return null;
  const validateTimeRange = (date: string | number | Date): boolean => {
    if (isDateInFuture(new Date(date))) {
      return false;
    }
    if (isDateEnabled) {
      return isDateEnabled(new Date(date), filters);
    }
    return true;
  };

  if (isFilterOpen) {
    return (
      <Col sm={12} md={6} lg={4}>
        <Spacer marginY="xs">
          <Label>{title}</Label>
          <Datepicker
            id={keyName}
            inputProps={{ placeholder: 'MM/DD/YYYY' }}
            onChange={(date: string | number | Date) => handleChange(date)}
            value={value}
            getIsValidDate={validateTimeRange}
          />
        </Spacer>
      </Col>
    );
  }

  return (
    <Col sm={6} md={4}>
      <StyledPill padding="sm" margin="xs">
        <Flex display="flex" justifyContent="space-between">
          <div>
            <Text as="div" fontType="bodySmallHeading">
              {title}
            </Text>
            <Text as="div" fontType="bodySmall">
              {new Date(value || new Date()).toLocaleDateString()}
            </Text>
          </div>
          <CloseButton onClick={() => handleClearFilter(undefined)} />
        </Flex>
      </StyledPill>
    </Col>
  );
};

export default DateFilterPill;
